import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, IconButton } from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DataTable from "../../components/common/DataTable";
import CustomModal from "../../components/common/CustomModal";
import { genericPost } from '../../services/authServices';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CustomLoader from "../../components/common/CustomLoader";
import MessageBox from "../../components/common/CustomMessageBox";
import { AuthContext } from "../../context/AuthContext";
import CustomDelete from '../../components/common/CustomDeleteAlert'
import CustomMaster from '../../components/common/CustomMaster'
import axios from "axios";
import CreateBlogPost from "../components/CreateForm/CreateBlogPost";
import UpdateBlogPost from "../components/UpdateForm/UpdateBlogPost";
import { BLOG_GET, BLOG_DELETE } from "../../services/apiRoutes";
import { getBlogCategoryList, getBlogStatusList } from "../../services/CommonServices";


const title = "blog post";

const BlogPost = () => {
    const { token } = useContext(AuthContext)
    const [modal, setModal] = useState(false);
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const [updateModal, setUpdateModal] = useState(false);
    const [blogCategory, setBlogCategory] = useState([]);
    const [blogStatus, setBlogStatus] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }
    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };

    const handleUpdateClick = (blogId) => {
        setSelectedId(blogId);
        setUpdateModal(true);
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: "index",
                header: "SN.",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableColumnFilter: false,
            },
            {
                accessorKey: "title",
                header: "Title",
                tableHeader: { justifyContent: "flex-start" },
                size: 200,
            },
            {
                accessorKey: "category",
                header: "Category",
                tableStyle: { textAlign: "center" },
                size: 100,
            },
            {
                accessorKey: "authorName",
                header: "Author",
                tableHeader: { justifyContent: "flex-start" },
                size: 150,
            },
            {
                accessorKey: "views",
                header: "Views",
                tableStyle: { textAlign: "center" },
                size: 80,
            },
            {
                accessorKey: "status",
                header: "Status",
                tableStyle: { textAlign: "center" },
                size: 100,
                Cell: ({ cell }) => (
                    <span
                        style={{
                            color:
                                cell.getValue() === "Published"
                                    ? "green"
                                    : "orange",
                            fontWeight: "bold",
                        }}
                    >
                        {cell.getValue()}
                    </span>
                ),
            },
            {
                accessorKey: "publishedAt",
                header: "Published Date",
                tableStyle: { textAlign: "center" },
                size: 150,
                Cell: ({ cell }) =>
                    cell.getValue()
                        ? new Date(cell.getValue()).toLocaleDateString()
                        : "",
            },
            {
                accessorKey: "createdAt",
                header: "Created At",
                tableStyle: { textAlign: "center" },
                size: 150,
                Cell: ({ cell }) =>
                    cell.getValue()
                        ? new Date(cell.getValue()).toLocaleDateString()
                        : "",
            },
            {
                accessorKey: "action",
                header: "Action",
                size: 100,
                Cell: ({ row }) => (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "4px",
                        }}
                    >
                        <IconButton
                            onClick={() => handleUpdateClick(row.original.blogId)}
                        >
                            <ModeEditOutlineOutlinedIcon
                                style={{ color: "#050C9C" }}
                            />
                        </IconButton>

                        <IconButton
                            onClick={() =>
                                handleOpenDeleteAlert(row.original.blogId)
                            }
                        >
                            <DeleteOutlineOutlinedIcon
                                style={{ color: "#E4003A" }}
                            />
                        </IconButton>
                    </div>
                ),
            },
        ],
        []
    );

    const getBlogList = async () => {
        setLoading(true);
        try {
            const response = await genericPost(BLOG_GET, {});

            if (response.data.success && response.data.blogs) {
                const blogData = response.data.blogs.map((blog, index) => ({
                    blogId: blog.blogId || '',
                    index: (index + 1).toString().padStart(2, '0'),

                    userId: blog.userId || '',
                    companyId: blog.companyId || '',

                    title: blog.title || '',
                    content: blog.content || '',
                    featuredImage: blog.featuredImage || '',
                    category: blog.categoryList?.categoryName || '',
                    status: blog.statusList?.statusName || '',

                    metaTitle: blog.metaTitle || '',
                    metaDescription: blog.metaDescription || '',

                    views: blog.views || 0,

                    publishedAt: blog.publishedAt || '',
                    createdAt: blog.createdAt || '',
                    updatedAt: blog.updatedAt || '',

                    authorName: blog.user
                        ? `${blog.user.firstName || ''} ${blog.user.lastName || ''}`
                        : '',
                }));

                setBlogs(blogData);
            } else {
                setError('No blogs found');
            }
        } catch (error) {
            setError('Error fetching blogs');
            console.error('Error fetching blogs', error);
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async (blogId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(BLOG_DELETE(blogId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: "Blog deleted successfully",
                    type: "success",
                });

                getBlogList();
                setDeleteAlert(false);
            }
        } catch (error) {
            setLoading(false);
            setMessage({
                open: true,
                text: "Error deleting blog",
                type: "error",
            });
        }
    };
    useEffect(() => {
        getBlogList()
    }, [token])

    const handleOpen = () => {
        setModal(true);
    };
    const handleClose = () => {
        setModal(false)
    }


    useEffect(() => {
        getCommonData()
    }, [])

    const getCommonData = async () => {
        const blogCategoryList = await getBlogCategoryList()
        setBlogCategory(blogCategoryList);
        const blogStatusList = await getBlogStatusList()
        setBlogStatus(blogStatusList);
    }

    const defaultView = 'blogpost';
    const mainContent = (
        <>
            <Box sx={{ padding: "10px" }}>
                <CustomLoader open={loading} />
                <DataTable
                    title={title}
                    columns={columns}
                    data={blogs}
                    handleOpen={handleOpen}
                    buttonTitle="Add Blog Post"
                />
                <CustomModal

                    open={modal} handleClose={handleClose}>
                    <CreateBlogPost
                        handleClose={handleClose}
                        fetchData={getBlogList}
                        setMessage={setMessage}
                        blogCategory={blogCategory}
                        blogStatus={blogStatus}
                    />
                </CustomModal>
                <CustomModal

                    open={updateModal} handleClose={handleCloseUpdate}>
                    <UpdateBlogPost
                        handleClose={handleCloseUpdate}
                        blogId={selectedId}
                        getBlogList={getBlogList}
                        setMessage={setMessage}
                        blogCategory={blogCategory}
                        blogStatus={blogStatus}
                    />
                </CustomModal>
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />

            </Box>
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </>
    );

    return (
        <CustomMaster
            defaultView={defaultView}
            mainContent={mainContent} />
    );
};
export default BlogPost;

